import { Component,Input, Inject } from '@angular/core';
import { Motor } from '../../models/Motor';
import { Actuator } from '../../models/Actuator';
import { MFGDBColumn } from '../../models/MFGDBColumn';
import { MAT_DIALOG_DATA,MatDialogRef } from '@angular/material/dialog';
import { ConversionService } from '../../services/ConversionService';
import { FeedbackCode } from '../../models/FeedbackCode';
import { FeedbackDevice } from '../../models/FeedbackDevice';
@Component({
  selector: 'app-motordata',
  templateUrl: './motordata.component.html',
  styleUrl: './motordata.component.css'
})
export class MotordataComponent {
  @Input() SelectedMotor: Motor;
  @Input() SelectedActuator: Actuator;
  @Input() SelectedFeedback: FeedbackCode;
  @Input() SelectedFeedbackDevice: FeedbackDevice;
  @Input() ColumnsToShow: MFGDBColumn[];
  @Input() ObjectType: string;

  constructor(private convServ: ConversionService, public dialogRef: MatDialogRef<MotordataComponent>, @Inject(MAT_DIALOG_DATA) public data: any) {
    
    if (this.data.objectType == "Motor") {
      this.SelectedMotor = this.data.selectedMot;
      this.SelectedActuator = this.data.selectedAct;
      this.SelectedFeedback = new FeedbackCode();
      this.SelectedFeedbackDevice = new FeedbackDevice();
    }
    else {
      this.SelectedFeedbackDevice = this.data.selectedFeedbackDevice;
      this.SelectedFeedback = this.data.selectedFeedback;
      this.SelectedMotor = new Motor();
      this.SelectedActuator = new Actuator();
    }
    this.ColumnsToShow = this.data.columns;
    this.ColumnsToShow = this.ColumnsToShow.sort((a, b) => a.SortOrder - b.SortOrder);
    this.ObjectType = this.data.objectType;
    

  }

  GetDataValue(column: string, defaultValue:string): string {
    if (column.toLowerCase() != "custom" && (defaultValue == "" || defaultValue == null)) {
      if (this.ObjectType == "Motor") {
        let str = column as keyof typeof this.SelectedMotor;
        return this.SelectedMotor[str] ? this.SelectedMotor[str].toString() : "";
      } else {
        let str = column as keyof typeof this.SelectedFeedbackDevice;
        return this.SelectedFeedbackDevice[str] ? this.SelectedFeedbackDevice[str].toString() : "";
      }
    }
    else {
      return defaultValue;
    }
  }



  GetDefaultValue(column: string) {
    var retValue = "";
    if (this.ColumnsToShow.filter(x => x.DBColumnName == column).length > 0) {
      retValue = this.ColumnsToShow.filter(x => x.DBColumnName == column)[0].DefaultValue;
    }

    return retValue;
  }

  GetUnitFromUOM(uom: string, dbColumnUOM:string) {
    return this.convServ.GetUnitFromString(uom == "" ? dbColumnUOM : uom);
  }

  onNoClick(): void {
    this.dialogRef.close();
  }
}
